// extracted by mini-css-extract-plugin
export default {"badge":"ImageOverlays_badge__2-S0J","errorMessage":"ImageOverlays_errorMessage__2F8yP"};